/**
 * Which services are the bank's internal tools -- the canteen booking
 * system, the wiki, the corporate blog -- held behind a toggle wherever
 * a service is picked to admit or to rest a function on.
 *
 * ROUND 15 H7 for the promote form; round 18 L13 for the function
 * register's raise form, which offered them on the same list as the
 * services a treasury function actually rests on. Still the bank's to
 * pick, not the product's to hide.
 */
export const CLASSIFICATION_RANK: Record<string, number> = {
  ibs_supporting: 0,
  supporting: 1,
  non_critical: 2,
  out_of_scope: 3,
};

/**
 * Round 19 L14 -- "not critical" is not "an internal tool". Round 18's
 * rule held every `non_critical` service back, so a treasury function
 * could not be raised over its own treasury system (Treasury
 * Management, `non_critical`) without opening the fold. Only what the
 * bank marks as an internal tool, or puts out of scope, is held back.
 */
export function isInternalTool(service: {
  classification?: string | null;
  internal_tool?: boolean | null;
}): boolean {
  return service.internal_tool === true || service.classification === "out_of_scope";
}
